import { Component, Input } from '@angular/core';
import { TotalStatisticByMonth } from '@classes/client-statistics/client-statistics-by-month';

@Component({
  selector: 'app-crm-total-card',
  templateUrl: './crm-total-card.component.html',
  styleUrls: ['./crm-total-card.component.scss']
})
export class CRMTotalCardComponent {

  @Input() total: TotalStatisticByMonth = null;

}
